
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import personPick from '../common/personPick.vue'
import datePick from '../common/datePick.vue'
import choosePerson from '../common/choosePerson.vue'
import ConsignPick from '../common/ConsignPick.vue'
import Agreement from '../common/Agreement.vue'
var DEBOUNCE_TIME = 400;
export default{
components:{
Group,
Cell,
XInput,
Badge,
XButton,
Icon,
personPick,
datePick,
choosePerson,
PopupPicker,
Agreement,
ConsignPick
},
data(){
return {
list3:[],
showPopupPicker:false,
upvalue:'新南门汽车站',
downvalue:'',
jsDate:'',
jsPerson:['1'],
personList:[[1,2,3,4,5]], //pick数据
conso:"",
jsPassanger:'', //联系人
defaultFlag:true,
checkBoxFlag:true,//服务须知
checkBoxValue:'success',             airInfo:{//航班信息
airLineCode:"",
airLineCompany:"",
airLineEndName:"",
airLineEndTime:"",
airLineStartName:"",
airLineStartTime:"",
state:"",
start:"",
end:""
},
jbStorage:JSON.parse(localStorage.getItem("jbStorage")) || {},
post:"",
payPrice:"", //实际支付的金额
activityName:"",
showAgree:false,
mrDate:"",
ProtocolDetail:"",
userToken:this.$until.getUrlParam('openId') || localStorage.getItem("cdqcp_opid") ||  localStorage.getItem("useCar_cdqcp_opid"),
}
},
watch:{
'checkBoxFlag':function(newValue,oldValue){
this.checkBoxValue = newValue ? 'success' : 'circle';
},
'airInfo':function(newValue,oldValue){
this.bindDateAndPerson(newValue.endCityNo);
setTimeout(()=>{

if(this.mrDate){
this.callPrice()
}
},300)
},
'downvalue':function(newValue,oldValue){
setTimeout(()=>{
if(this.mrDate){
this.callPrice()
}
},300)
},
'jsDate':function(newValue,oldValue){
setTimeout(()=>{
this.callPrice()
},300)
},
'jsPerson':function(newValue,oldValue){
setTimeout(()=>{
this.callPrice()
},300)
},
jsPassanger:function(newValue, oldValue){
setTimeout(()=>{
this.callPrice();
}, 300);
},
},
methods:{
yz(val){
return this.$until.yzFontColor(val);
},
getupvalue(){

this.$router.push('/serachAircraft')
},
getdownvalue(){
if(!this.airInfo.endCityNo){
this.$vux.toast.show({
text:"请先设置起点",
type:"text"
})
return;
}
this.$router.push('/arriveAddressB?ness=Air&title=1&cityNo='+this.airInfo.endCityNo)
},
queryProtocolDetail(){
this.$http.post(window.innerAPI + "?server=queryProtocolDetail",{
code:'p_shuttle'
}).then(res =>{

this.ProtocolDetail = res.data.data.content
}).catch(err =>{
});
},

callPrice(){


if (!this.airInfo.airLineCode || !this.downvalue || (!this.jsDate && !this.mrDate)){

return;
}


this.$http.post(window.innerAPI + "?server=queryShuttlePrice",{
"bizTypeStr":"5",
"downPoint":this.downvalue.point.lat + "," + this.downvalue.point.lng,
"startSiteNo":this.airInfo.siteNo,
"numbers":this.jsPerson[0],
"useDate":this.$until.updateDate(this.jsDate || this.mrDate),
"userToken":this.userToken
}).then(res =>{
this.payPrice = res.data.data.data.notCarpoolPayPrice;
this.activityName = res.data.data.data.details[0].activityName;
}).catch(err =>{

});
},

submit(){
if (!this.airInfo || !this.downvalue || (!this.jsDate && !this.mrDate) || !this.jsPerson || !this.jsPassanger){
this.$vux.toast.show({
text:"请完善订单信息",
type:"text"
})
return;
} else if (!this.checkBoxFlag){
this.$vux.toast.show({
text:"请同意服务协议",
type:"text"
})
return;
} else {

}
var arr = [];
for(var i = 0; i < this.jsPerson; i++) {
arr.push({});
}
window.clearTimeout(this.tId);
var _p_from = this.$until.judgeBrowser();
this.tId =  setTimeout(()=>{

this.$http.post(window.innerAPI + "?server=initOrder",{
"bizType":"5",
"shiftNo":this.airInfo.airLineCode,
"baggage":this.conso,
"downPoint":this.downvalue.point.lat + "," + this.downvalue.point.lng,
"lineSiteSartNo":this.airInfo.siteNo,
"lineSiteEndNo":"",
"numbers":this.jsPerson[0],
"bookDate":this.$until.updateDate(this.jsDate||this.mrDate).split(" ")[0],
"driverTime":this.$until.updateDate(this.jsDate||this.mrDate).split(" ")[1],
"contactMobile":this.jsPassanger.split(' ')[1],
"contactName":this.jsPassanger.split(' ')[0],
"upAddress":this.airInfo.airLineEndName,
"downAddress":this.downvalue.address,
"userToken":this.userToken,
"passengersStr":JSON.stringify(arr),
"_p_from":_p_from
}).then(res =>{
if(res.data.data.code == "30000"){
this.$vux.toast.show({
text: res.data.data.errmsg,
type: "text"
});
return;
}
if(res.data.msg){
this.$vux.toast.show({
text: res.data.msg,
type: "text"
});
return;
}

if(res.data.data.code){
this.$vux.toast.show({
text: "下单失败",
type: "text"
})
return;
}

if(res.data.data){
this.$until.getBackUrl(this,res.data.data.orderNo);

}
}).catch(err =>{
});
},DEBOUNCE_TIME)
},

bindDateAndPerson(cityNo){
var that = this;
this.$until.getDateTime(this,cityNo,'queryAirPortConfig').then(function(data){
that.list3 = data.jspickerDate;
that.personList = [data.personList];
})
},
},
activated(){
this.payPrice = "";
this.$store.state.mutations.path = "pickupAircraft";
this.$store.state.mutations.cityAddress = false;
},
mounted(){
this.payPrice = "";
this.$store.state.mutations.path = "pickupAircraft";
this.$store.state.mutations.cityAddress = false;
if (this.jbStorage.airInfo){
this.airInfo = this.jbStorage.airInfo
this.mrDate =  this.airInfo.airDateFault != "0" ? this.airInfo.lineDate+" "+ this.airInfo.airLineEndTime : "";
this.jsDate =  this.airInfo.airDateFault != "0" ? this.airInfo.lineDate+" "+ this.airInfo.airLineEndTime : "";
}
if (this.jbStorage.mapAddress){
this.downvalue = this.jbStorage.mapAddress;
}
this.queryProtocolDetail();
}
}



// WEBPACK FOOTER //
// ./src/components/pickGiveAircraft/pickupAircraft.vue